module.exports = __webpack_public_path__ + "img/computer.49f318c0.svg";